import {apiService} from "../api.service";
import {SystemWithGroups} from "../../models/system/system.groups";

export class SystemsService {
    public async getSystemGroups(): Promise<SystemWithGroups[]> {
        return (await apiService.get<SystemWithGroups[]>("users/accesses/systems")).data;
    }
}

export const systemsService = new SystemsService();